// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 * NOTA: Les hores de sol es poden informar de dues maneres:
 *       - Informar només el total d'hores.
 *       - Informar totes les franges temporals i que el sumatori coincideixi amb el total d'hores.
 ***/
export const ID_HORES_DE_SOL_TOTALS = 29;
export const ID_HORES_DE_SOL_ENTRE_00_I_07H = 30;
export const ID_HORES_DE_SOL_ENTRE_07_I_13H = 31;
export const ID_HORES_DE_SOL_ENTRE_13_I_18H = 32;
export const ID_HORES_DE_SOL_ENTRE_18_I_24H = 33;

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_SI_ALGUNA_FRANJA_DE_SOL_INFORMADA_ALESHORES_TOTES_FRANGES_INFORMADES = 'S\'han d\'informar totes les franges temporals o no informar-ne cap.';

/*
 * Funcions auxiliars que ajuden a la legibilitat
 ***/

const estanFrangesHoresSolIncompletes = (horesDeSolFrangesValor) => {
    const hiHaAlgunaFranjaNoInformada = horesDeSolFrangesValor.some(horesDeSolFranjaValor => horesDeSolFranjaValor === null);
    const hiHaAlgunaFranjaInformada = horesDeSolFrangesValor.some(horesDeSolFranjaValor => horesDeSolFranjaValor !== null);
    return hiHaAlgunaFranjaInformada && hiHaAlgunaFranjaNoInformada;
};

/*
 * Grup Insolació
 ***/
export const checkGrupInsolacio = (nouVariables) => {

    // Variables
    const horesDeSolTotals = obteVariable(ID_HORES_DE_SOL_TOTALS, nouVariables);
    const horesDeSolEntre00i07 = obteVariable(ID_HORES_DE_SOL_ENTRE_00_I_07H, nouVariables);
    const horesDeSolEntre07i13 = obteVariable(ID_HORES_DE_SOL_ENTRE_07_I_13H, nouVariables);
    const horesDeSolEntre13i18 = obteVariable(ID_HORES_DE_SOL_ENTRE_13_I_18H, nouVariables);
    const horesDeSolEntre18i24 = obteVariable(ID_HORES_DE_SOL_ENTRE_18_I_24H, nouVariables);

    if (!horesDeSolTotals || !horesDeSolEntre00i07 || !horesDeSolEntre07i13 || !horesDeSolEntre13i18 || !horesDeSolEntre18i24) {
        return;
    }

    // Valors de variables
    const horesDeSolEntre00i07Valor = obteValorVariable(horesDeSolEntre00i07);
    const horesDeSolEntre07i13Valor = obteValorVariable(horesDeSolEntre07i13);
    const horesDeSolEntre13i18Valor = obteValorVariable(horesDeSolEntre13i18);
    const horesDeSolEntre18i24Valor = obteValorVariable(horesDeSolEntre18i24);

    // Arrays auxiliars amb les diferents variables/valors de franges d'hores
    const horesDeSolFranges = [horesDeSolEntre00i07, horesDeSolEntre07i13, horesDeSolEntre13i18, horesDeSolEntre18i24];
    const horesDeSolFrangesValor = [horesDeSolEntre00i07Valor, horesDeSolEntre07i13Valor, horesDeSolEntre13i18Valor, horesDeSolEntre18i24Valor];

    if (estanFrangesHoresSolIncompletes(horesDeSolFrangesValor)) {
        // Si una franja horaria està informada la resta també ho han d'estar. O totes o cap.
        // Afegim error a totes les franges
        horesDeSolFranges.forEach(horesDeSolFranja => {
            afegeixErrorAVariable(horesDeSolFranja, MSG_SI_ALGUNA_FRANJA_DE_SOL_INFORMADA_ALESHORES_TOTES_FRANGES_INFORMADES);
        });
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupInsolacio.js